import styled from 'styled-components';

import { colors } from 'styles/theme/colors';

// A count in an admin list cell that opens a slideout listing the counted records.
const CountLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.blue100};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    opacity: 0.75;
  }
`;

export default CountLink;
